import { PREFS_DISABLE_MANUAL_NOTIFICATION_PROMPT_KEY } from "./constants";
// prefs
const isManualNotificationPromptDisabled = () => {
  return !!localStorage.getItem(PREFS_DISABLE_MANUAL_NOTIFICATION_PROMPT_KEY);
};
export const Selectors = {
  isManualNotificationPromptDisabled,
};
